module.exports = __webpack_public_path__ + "img/h11.8492cb3a.png";